
export class AppConfigModel {
    public appName: string;
    public locale: string;
    public title: string;
    public logo: string;
    public logoWhite: string;
    public logoMain: string;
    public googleTagManagerCode: string;
    public googleAnalyticsCode: string;
    public banner: string;
    public logoWithName: string;
    public appDefaultRoute: string;
    public firstPageHeaderText: string;
    public firstPageSubHeaderText: string;
    public firstPageHeaderDescription: string;
    public firstPageFooterDescription: string;
    public payPalPaymentMode: string;

    public theme: string;
    public base: string;
    public apiUrl: string;
    public appUrl: string;
    public bookingAvailableDaysChecking: number = 0;
    public enable30Days: boolean;
    public calendarViewCount: number = 1;
    public sessionGroupCode: string;
    public apiKey: string;
    public controllerRoute: string;
    public digitalGlueVoucherPattern: string;
    public digitalGlueVoucherPrefix: string;
    public appintmentVoucherNotes: string;
    public appintmentNotSecuredNotes: string;
    public appintmentFailedVoucherNotes: string;

    public docuUrl: string;

    public payPalSandboxCliendId: string;
    public payPalProductionCliendId: string;
    public payPalCurrencyCode: string;
    public currencySymbol: string;

    public thankYouPageHeader: string;
    public thankYouPageFirstParagraph: string;
    public thankYouPageLastParagraph: string;
    public thankYouPageButtonLink: string;
    public thankYouPageButtonCaption: string;

    public invalidPageHeader: string;
    public invalidPageFirstParagraph: string;
    public invalidPageLastParagraph: string;
    public invalidPageButtonLink: string;
    public invalidPageButtonCaption: string;

    public showStaff: boolean;
    public idleTimeOut: number;
    public version: string;

    public invalidBarcodeMessage: string;
    public enable7Days: boolean;
    public disableWeekDays: number[];
    public defaultBranchId: string;
    public sagePayButtonText: string;

    public mainWebsiteUrl: string;

    public page1Header: string;
    public page1SubHeader: string;

    public page3Header: string;
    public page3SubHeader: string;

    public page4Header: string;
    public page4SubHeader: string;
    
    public forceUserToVerifyEmailAddress: string;
    public enablePayPalButton: string;

    public showGroupHeader: boolean;
    public showItemPriceAndName: boolean;
    public showAddToButton: boolean;
    
    public existingAccountNeedMigration: string;
    public migrationSubText: string;
    public migrationSubTextThankYou: string;
    public successfulAccountActivation: string;
    public depositNotes: string;
    public enableCovid: boolean;

    public showSteps: string;
    
    public stepAppointment: string;
    public stepLogin: string;
    public stepConfirm: string;
    public stepComplete: string;

    public showIncomingAppointments: boolean;
    public showTransactionHistory: boolean;
    public showHomeMenu: boolean;

    public address1NotAllowStringFilter: string;
    public enablePermanentDataEditing: boolean;
    public showProfileLink: boolean;

    public basicInformationDuplicateMessage: string;
    public enablePopUpDialogOnRegistrationFirstLoad: boolean;
    public popUpDialogOnRegistrationMessage: string;
    public popUpDialogOnAddressClickMessage: string;
    public disableNewClientFilter: boolean;

    public loginEnableStartUpPopUpMessage: boolean;
    public loginStartUpPopUpMessageContent: string;
    public loginStartUpPopUpContinueButtonText: string;
    public loginStartUpPopUpTitleText: string;
    public loginAgreeCheckBoxNotTickMesssage: string;

}

  
export class BaseModel {
    public initializationVector: string;
    public encryptedId: string;
}


export class GetTokenBindingModel
{
    public email: string;
    public password: string;
    public grand_type: string;
    public username: string;
    constructor() {
        this.grand_type = "password";
    }
}

export class GetTokenViewModel
{
    public access_token: string;
    public expires_in: string;
    public token_type: string;
    public userName: string;
}

